import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL, VIDEO_SIZES } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularMedia from '~/components/atoms/Editorial/RegularMedia.vue';
var COLORS = {
  grey: 'btn-dark',
  white: 'btn-white',
  transparent: 'btn-transparent'
};
export default {
  name: 'PresentationNews',
  components: {
    TitleSection: TitleSection,
    SimpleParagraph: SimpleParagraph,
    RegularMedia: RegularMedia
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor: function backgroundColor() {
      return this.payload.primary.background_color;
    },
    backgroundImage: function backgroundImage() {
      return formatPrismicImage(this.payload.primary.background_image.url);
    },
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    textColor: function textColor() {
      return this.payload.primary.title_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    button: function button() {
      return {
        text: this.payload.primary.button_text,
        color: COLORS[this.payload.primary.button_color],
        url: this.payload.primary.button_url.url,
        target: this.payload.primary.button_url.target,
        tracking: {
          data: {
            event_category: this.payload.primary.event_category,
            event_action: this.payload.primary.event_action,
            event_label: this.payload.primary.event_label
          }
        }
      };
    },
    alt: function alt() {
      return this.payload.primary.alt;
    },
    src: function src() {
      return formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
    },
    videoImages: function videoImages() {
      var _this = this;

      return Object.entries(VIDEO_SIZES).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _objectSpread({}, acc, _defineProperty({}, key, formatPrismicImage(_this.payload.primary.image.url, ["w_".concat(value)]) || EMPTY_PIXEL));
      }, {});
    },
    srcset: function srcset() {
      var small = formatPrismicImage(this.payload.primary.image.url, ['w_375']) || EMPTY_PIXEL;
      var medium = formatPrismicImage(this.payload.primary.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
      var large = formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage(this.payload.primary.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
      return "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w");
    },
    imagePosition: function imagePosition() {
      return this.payload.primary.image_position;
    },
    videos: function videos() {
      var _this2 = this;

      return {
        mp4: Object.entries(VIDEO_SIZES).reduce(function (acc, _ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              value = _ref4[1];

          return _objectSpread({}, acc, _defineProperty({}, key, formatPrismicImage(_this2.payload.primary.video_mp4.url, ["w_".concat(value, ",q_auto,f_auto")], '', 'video')));
        }, {}),
        webm: Object.entries(VIDEO_SIZES).reduce(function (acc, _ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          return _objectSpread({}, acc, _defineProperty({}, key, formatPrismicImage(_this2.payload.primary.video_webm.url, ["w_".concat(value, ",q_auto,f_auto")], '', 'video')));
        }, {}),
        auto_play: this.payload.primary.video_auto_play === 'Yes',
        play_color: this.payload.primary.video_play_color,
        mute_video: this.payload.primary.mute_video
      };
    }
  }
};